


import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
    templateUrl: 'device-list.component.html',
  standalone: false
})
export class FoodSafetyDeviceListComponent implements OnInit {

    constructor( private fb: FormBuilder) {

    }

    ngOnInit(): void {

    }

}
